import { colors } from "../../../core";

export enum ThemeName {
  DEFAULT = "Default",
  BOTTOM_BLUE_OFFSET = "Bottom Blue with Offset",
}

export interface ThemeStyles {
  primaryColor: string;
  lastModuleColor?: string;
}

export const useTheme = (themeName?: ThemeName): ThemeStyles => {
  switch (themeName) {
    case ThemeName.BOTTOM_BLUE_OFFSET:
      return {
        primaryColor: colors.white.value,
        lastModuleColor: colors.paleBlueLight.value,
      };
    case ThemeName.DEFAULT:
    default:
      return {
        primaryColor: colors.white.value,
      };
  }
};
